import { authService } from "@/services/auth-service";
import Cookies from "js-cookie";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";

const useAuthentication = () => {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    watch,
  } = useForm();
  const [isLoading, setIsLoading] = useState(false);

  const onSubmitLogin = async (data) => {
    setIsLoading(true);
    try {
      const response = await authService.login(data);
      Cookies.set("accessToken", response?.accessToken, { expires: 7 });
      Cookies.set("userProfile", JSON.stringify(response));
      // toast.success("Login successful!");
      navigate("/my-accounts");
    } catch (error) {
      toast.error(
        error.response?.data?.message ||
          "The username or password you entered is incorrect. Please try again or reset your password.",
      );
    } finally {
      setIsLoading(false);
    }
  };

  const onSubmitRegister = async (data) => {
    setIsLoading(true);
    try {
      const response = await authService.register(data);
      /* toast.success("Registration successful! You can now log in.");
      console.log("Register response:", response); */
      navigate("/sign-in");
      return response;
    } catch (error) {
      toast.error(
        error.response?.data?.message ||
          "An error occurred during registration.",
      );
    } finally {
      setIsLoading(false);
    }
  };

  const onSubmitForgotPassword = async (data) => {
    setIsLoading(true);
    try {
      // const response = await authService.forgotPassword(data);
      console.log(data);
      navigate("/forget-password-message");
      // console.log("Forgot Password response:", response);
    } catch (error) {
      toast.error(
        error.response?.data?.message ||
          "An error occurred while requesting a password reset.",
      );
    } finally {
      setIsLoading(false);
    }
  };

  const onSubmitResetPassword = async (data) => {
    setIsLoading(true);
    try {
      console.log(data);
      // const response = await authService.resetPassword(data);
      // toast.success("Password reset successful!");
      // console.log("Reset Password response:", response);
      navigate("/sign-in");
    } catch (error) {
      toast.error(
        error.response?.data?.message ||
          "An error occurred while resetting the password.",
      );
    } finally {
      setIsLoading(false);
    }
  };

  const onSubmitUpdateEmail = async (data) => {
    setIsLoading(true);
    try {
      const response = await authService.updateEmail(data);
      // toast.success("Email updated successfully!");
      console.log("Update Email response:", response);
      navigate("/my-accounts");
    } catch (error) {
      toast.error(
        error.response?.data?.message ||
          "An error occurred while updating the email.",
      );
    } finally {
      setIsLoading(false);
    }
  };

  const logout = async () => {
    setIsLoading(true);
    try {
      Cookies.remove("accessToken");
      Cookies.remove("userProfile");
      Cookies.remove("selectedProfile");
      // const response = await authService.logout();
      // toast.success("Logged out successfully.");
      // console.log("Logout response:", response);
      navigate("/");
    } catch (error) {
      toast.error(
        error.response?.data?.message || "An error occurred during logout.",
      );
    } finally {
      setIsLoading(false);
    }
  };

  const contactUs = async (body) => {
    setIsLoading(true);
    try {
      const response = await authService.contactUs(body);
      toast.success(response?.message || "Message sent successfully!");
    } catch (error) {
      toast.error(
        error.response?.data?.message || "An error occurred during contact us.",
      );
    } finally {
      setIsLoading(false);
    }
  };

  return {
    contactUs,
    isLoading,
    register,
    handleSubmit,
    errors,
    setValue,
    watch,
    onSubmitLogin,
    onSubmitRegister,
    onSubmitForgotPassword,
    onSubmitResetPassword,
    onSubmitUpdateEmail,
    logout,
  };
};

export default useAuthentication;
